import { storage } from "../schmucklicloud";

const FitnessWorkouts = {
    add: async function(name, date, activities, is_draft = false, start_time = null, duration = 0) {
        var response = await storage.insert("fitness_workouts", {
            name: name,
            date: date,
            activities: JSON.stringify(activities),
            is_draft: is_draft ? "1" : "0",
            start_time: start_time,
            duration: Number(duration) || 0
        });

        return response;
    },

    edit: async function(id, name, date, activities, is_draft = false, start_time = null, duration = 0) {
        var response = await storage.update("fitness_workouts", id, {
            name: name,
            date: date,
            activities: JSON.stringify(activities),
            is_draft: is_draft ? "1" : "0",
            start_time: start_time,
            duration: Number(duration) || 0
        });

        return response;
    },
    
    delete: async function(id) {
        var response = await storage.delete("fitness_workouts", id);
        return response;
    },

    loadAll: async function() {
        var response = await storage.getAll("fitness_workouts", {
            column: "date",
            order: "desc"
        });
        if (response.isOK && response.data) {
            let mappedData = response.data.map(item => {
                let flatItem = { id: item.id, ...item.data };
                try {
                    flatItem.activities = JSON.parse(flatItem.activities);
                } catch(e) {
                    flatItem.activities = [];
                }
                flatItem.is_draft = (flatItem.is_draft === "1" || flatItem.is_draft === true);
                return flatItem;
            });
            return { isOK: true, data: mappedData };
        }
        return response;
    },

    loadSpecificDate: async function(date) {
        var response = await storage.get("fitness_workouts", [
            {
                column: "date",
                operator: "==",
                value: date
            }
        ]);
        if (response.isOK && response.data) {
            let mappedData = response.data.map(item => {
                let flatItem = { id: item.id, ...item.data };
                try {
                    flatItem.activities = JSON.parse(flatItem.activities);
                } catch(e) {
                    flatItem.activities = [];
                }
                flatItem.is_draft = (flatItem.is_draft === "1" || flatItem.is_draft === true);
                return flatItem;
            });
            return { isOK: true, data: mappedData };
        }

        return response;
    }
};

export default FitnessWorkouts;
